import cx from "classnames";

import * as StateLib from "@/Utils/StateLib";
import {
  Checkbox,
  ColorPickerControl,
  mergeProps,
  OverlayHeader,
  Text,
  Flex
} from "@theorgchartdev/storybook";
import { ReRenderCanvas } from "@/Utils/StateLib";
import { getLocalizedColorPickerStrings } from "@/Utils/Utils";
import { Globals } from "@coreapp/CoreApp/Globals";
import { appstr } from "@coreapp/utils/appstr";
import { getFeatureAccess } from "@/Utils/Misc";
import { enumFeaturesList } from "@coreapp/constants";
import ActionListItem from "@/appComponents/Blocks/Composites/ActionListItem/ActionListItem";
import { planningTestId } from "@/appComponents/Navigation/RightSidebar/Utils/chartModeTestId";
import { ColorSquare } from "./MyHighlights";

export const SavedFilterHighlightList = props => {
  props = mergeProps(props, defaultProps);

  const ApplyChartFilters = () => {
    const wsMgr = StateLib.GetWSMgr();
    wsMgr.ApplyChartFilters();
    ReRenderCanvas();
    if (!Globals._accountInfo.ReadOnlyMode()) StateLib.SetDocDirty();
  };

  const ApplyChartHighlights = () => {
    const wsMgr = StateLib.GetWSMgr();
    wsMgr.ApplyChartHighlights();
    ReRenderCanvas();
    if (!Globals._accountInfo.ReadOnlyMode()) StateLib.SetDocDirty();
  };

  const ToggleSavedContent = targetID => {
    let contentList = props.GetSavedContent();
    const targetItem = contentList[targetID];
    let isActive = targetItem.GetFilterApplied();
    targetItem.SetFilterApplied(!isActive);
  };

  const savedContent = props.GetNormalizedSavedList();
  if (!savedContent || savedContent.length === 0) {
    return null;
  }

  return (
    <>
      <div className={"sidebar-content-container"}>
        {props.showHeader && (
          <div className={"sidebar-header--divider"}>
            <OverlayHeader
              title={
                props.type === "filters" ? appstr("Saved filters") : appstr("Saved highlights")
              }
              size="medium"
              labelSize="medium"
              modifier="default"
            />
          </div>
        )}
        {props.includeHighlightsInfo && (
          <Text size="small" style={{ margin: "16px 0" }}>
            {appstr("Saved highlights info")}
          </Text>
        )}
        {props.type === "filters"
          ? savedContent.map((item, index) => (
              <div
                key={`saved-filters-${item.id}`}
                className={cx(
                  "sidebar-content-item",
                  index > 0 ? "sidebar-content-item--divider" : ""
                )}
              >
                <div className="sidebar-flex-row">
                  <Checkbox
                    key={`${item.name}-${item.id}`}
                    id={item.id}
                    label={item.name}
                    size="medium"
                    checked={item.enabled}
                    disabled={!getFeatureAccess(enumFeaturesList.savedHighlights)}
                    onToggle={props.ApplySavedContent({
                      ApplyChartFilters,
                      ApplyChartHighlights,
                      ToggleSavedContent
                    })}
                    data-testid={`${planningTestId("filter", "saved") ?? "rsb-saved-filter"}-${item.id}`}
                  />
                </div>
              </div>
            ))
          : savedContent.map((item, index) => (
              <Flex key={index} className="ocn-filter-block-list-item">
                <ActionListItem
                  padding={"0px"}
                  innerFlexProps={{ alignItems: "center" }}
                  contentBefore={
                    <>
                      <Checkbox
                        key={`${item.name}-${item.id}`}
                        id={item.id}
                        size="medium"
                        checked={item.enabled ?? false}
                        disabled={!getFeatureAccess(enumFeaturesList.savedHighlights)}
                        onToggle={props.ApplySavedContent({
                          ApplyChartFilters: () => {},
                          ApplyChartHighlights,
                          ToggleSavedContent
                        })}
                        data-testid={`${planningTestId("highlight", "saved") ?? "rsb-saved-highlight"}-${item.id}`}
                      />
                      <ColorSquare color={item.color} />
                      <Text modifier={item.enabled ? "bold" : ""}>{item.name}</Text>
                    </>
                  }
                />
              </Flex>
            ))}
      </div>
    </>
  );
};

const defaultProps = {
  showHeader: true
};
